import { Getters } from 'vuex-smart-module';
import ConferencesState from './state';

export default class ConferencesGetters extends Getters<ConferencesState> {}
